import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";

const getPhotoLocationsById = createSelector([
  getDomain
], (domain) => domain.photoLocations.byId);

export default getPhotoLocationsById;
